import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { Image } from '@zillow/constellation';

import AnalyticsConstants from 'app/shared/constants/AnalyticsConstants';
import analyticsUtils from 'app/client/utils/analyticsUtils';

import WizardBodyTemplate from 'app/shared/components/WizardBodyTemplate';
import WizardActionFooter from 'app/shared/components/WizardActionFooter';
import HomeSearch from 'app/shared/images/HomeSearch.svg';

const propTypes = {
    onGoToPrevStep: PropTypes.func.isRequired,
    onGoToNextStep: PropTypes.func.isRequired,
};

const defaultProps = {};

const WizFindListingSuccess = ({
    onGoToNextStep,
    onGoToPrevStep,
}) => {
    const dispatch = useDispatch();
    const handleClickPrevStep = () => {
        dispatch(analyticsUtils.track.GAEventV2(
            AnalyticsConstants.GA_EVENTS.CLAIM_LISTINGS_CLICK_BACK,
            { label: AnalyticsConstants.CLAIM_LISTINGS_LABEL.LISTING_LOOKUP_SUCCESS },
        ));
        onGoToPrevStep();
    };

    const handleClickNextStep = () => {
        dispatch(analyticsUtils.track.GAEventV2(
            AnalyticsConstants.GA_EVENTS.CLAIM_LISTINGS_CLICK_NEXT,
            { label: AnalyticsConstants.CLAIM_LISTINGS_LABEL.LISTING_LOOKUP_SUCCESS },
        ));
        onGoToNextStep();
    };

    return (
        <WizardBodyTemplate
            title="Next, let's verify your contact information"
            subtitle="Now you’ve identified the listings, for security purposes we will need to verify your contact
            information in order to transfer your listings to Zillow Rental Manager."
            icon={<Image src={HomeSearch} />}
        >
            <WizardActionFooter
                onBackClick={handleClickPrevStep}
                onNextClick={handleClickNextStep}
                isBackDisabled={!onGoToPrevStep}
                isNextDisabled={!onGoToNextStep}
            />
        </WizardBodyTemplate>
    );
};

WizFindListingSuccess.propTypes = propTypes;
WizFindListingSuccess.defaultProps = defaultProps;

export default WizFindListingSuccess;
